<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="分成项目">
        <el-select v-model="query.divide_item" placeholder="请选择分成项目" clearable style="width: 150px">
          <el-option
            v-for="item in divideItemList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分成模式">
        <el-select v-model="query.divide_mode" placeholder="请选择分成模式" clearable style="width: 150px">
          <el-option label="营业额" value="1"></el-option>
          <el-option label="利润" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="请选择状态" clearable style="width: 150px">
          <el-option label="可用" :value="1"></el-option>
          <el-option label="不可用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="openAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #divide_item="{ row }">
        <div>{{ getDivideItemName(row.divide_item) }}</div>
      </template>
      <template #divide_mode="{ row }">
        <el-tag size="small" :type="row.divide_mode === '1' ? 'success' : 'warning'">
          {{ row.divide_mode === '1' ? '营业额' : '利润' }}
        </el-tag>
      </template>
      <template #status="{ row }">
        <el-tag size="small" type="success" v-if="row.status === 1">可用</el-tag>
        <el-tag size="small" type="danger" v-if="row.status === 0">不可用</el-tag>
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="success" @click="openUpdate(row)">编辑</el-button>
      </template>
    </auto-table>

    <addEdit ref="edit" @success="getList(1)"></addEdit>
  </div>
</template>

<script>
import addEdit from './tqUnionRatio/addEdit.vue';
import { unionRatioTypeList } from '../dict.js';

export default {
  components: {
    addEdit
  },
  data() {
    return {
      nav: { firstNav: "门店管理", secondNav: "联营分成比例" },
      divideItemList: unionRatioTypeList,
      DataList: [],
      query: {
        divide_item: null,
        divide_mode: null,
        status: null,
        mechanism_id: this.$route.query.mecID || null
      },
      Option: [
        { name: "排序", value: "sort_order" },
        { name: "分成项目", value: "divide_item", type: "custom" },
        { name: "分成模式", value: "divide_mode", type: "custom" },
        { name: "分成比例", value: "ratio" },
        { name: "状态", value: "status", type: "custom" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom" }
      ],
      Total: 0
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    openAdd() {
      this.$refs.edit.open();
    },
    openUpdate(row) {
      this.$refs.edit.open(row);
    },
    getDivideItemName(item) {
      const found = this.divideItemList.find(i => i.value === item);
      return found ? found.name : item;
    },
    // 列表查询
    getList(v) {
      let page = v || 1;
      let params = {
        currentPage: page,
        pageSize: 10,
        invest_id: 0,
        ...this.query
      };
      this.$axios({
        url: "/user/unionMechanismRatio/queryListPage",
        params
      }).then((res) => {
        this.DataList = res.data.data
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
